// v221 backup-verification audit (item 28 of docs/PRODUCT-ROADMAP.md,
// item 33 in the recommended delivery order). Reads the summary +
// history from /api/admin/backup-verifications.
//
// The CronJob ingests via POST /api/admin/backup-verifications/runs;
// the frontend never writes to that endpoint — it's CronJob-only.

import useSWR from 'swr';

export interface BackupVerificationSummary {
  runs_total: number;
  runs_pass: number;
  runs_fail: number;
  last_pass_id: string | null;
  last_pass_at: string | null;
  last_pass_duration_ms: number | null;
  last_pass_source: string | null;
  last_fail_id: string | null;
  last_fail_at: string | null;
  last_fail_error: string | null;
  last_fail_duration_ms: number | null;
  last_fail_source: string | null;
  seconds_since_last_pass?: number;
}

export interface BackupVerificationRun {
  id: string;
  started_at: string;
  finished_at: string | null;
  status: 'running' | 'pass' | 'fail';
  backup_source: string;
  backup_id: string;
  smoke_results?: Record<string, { ok: boolean; detail?: string; duration_ms?: number }>;
  error_msg: string | null;
  duration_ms: number | null;
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include', headers: { Accept: 'application/json' } }).then((r) => {
    if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
    return r.json();
  });

export function useBackupVerification() {
  return useSWR<BackupVerificationSummary>('/api/admin/backup-verifications', fetcher, {
    refreshInterval: 60_000,
  });
}

export function useBackupVerificationHistory(limit = 30) {
  return useSWR<BackupVerificationRun[]>(
    `/api/admin/backup-verifications/history?limit=${limit}`,
    fetcher,
    { refreshInterval: 60_000 },
  );
}
